(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("underscore"), require("@bingads-webui-universal/primitive-utilities"));
	else if(typeof define === 'function' && define.amd)
		define(["underscore", "@bingads-webui-universal/primitive-utilities"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("underscore"), require("@bingads-webui-universal/primitive-utilities")) : factory(root["underscore"], root["@bingads-webui-universal/primitive-utilities"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__8__) {
return 